var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconoirInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.49998 12C10.3398 12 11.1453 11.6839 11.7392 11.1213C12.333 10.5587 12.6666 9.79565 12.6666 9C12.6666 8.20435 12.333 7.44129 11.7392 6.87868C11.1453 6.31607 10.3398 6 9.49998 6C8.66013 6 7.85467 6.31607 7.26081 6.87868C6.66694 7.44129 6.33331 8.20435 6.33331 9C6.33331 9.79565 6.66694 10.5587 7.26081 11.1213C7.85467 11.6839 8.66013 12 9.49998 12Z",
    stroke: "#A3A3A3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.375 12V6C2.375 5.00544 2.79204 4.05161 3.53437 3.34835C4.2767 2.64509 5.28352 2.25 6.33333 2.25H12.6667C13.7165 2.25 14.7233 2.64509 15.4656 3.34835C16.208 4.05161 16.625 5.00544 16.625 6V12C16.625 12.9946 16.208 13.9484 15.4656 14.6517C14.7233 15.3549 13.7165 15.75 12.6667 15.75H6.33333C5.28352 15.75 4.2767 15.3549 3.53437 14.6517C2.79204 13.9484 2.375 12.9946 2.375 12Z",
    stroke: "#A3A3A3",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8542 4.88252L13.8617 4.87427",
    stroke: "#A3A3A3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoirInstagram);
export default __webpack_public_path__ + "static/media/iconoir_instagram.51a99c178af33c60aa1669cfc8f3a9f1.svg";
export { ForwardRef as ReactComponent };